import { render } from "./NewsShow.vue?vue&type=template&id=08153088&scoped=true"
import script from "./NewsShow.vue?vue&type=script&lang=js"
export * from "./NewsShow.vue?vue&type=script&lang=js"

import "./NewsShow.vue?vue&type=style&index=0&id=08153088&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08153088"]])

export default __exports__